import React, { useContext, useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import 'react-grid-layout/css/styles.css';
import { makeStyles } from '@material-ui/core/styles';
import { gql, useQuery, useMutation, useLazyQuery } from '@apollo/client';
import MUIDataTable from 'mui-datatables';
import { Typography } from '@material-ui/core';
import SaveIcon from '@mui/icons-material/Save';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import { GET_WIDGETS, GET_PRS, ADD_WIDGET, REMOVE_WIDGET, UPDATE_WIDGET } from '../util/schema';
import TabRenderer from '../components/TabRenderer.jsx';
import DashboardGrid from '../components/DashboardGrid.jsx';
import DashboardWidgetMenu from '../components/DashboardWidgetMenu.jsx';
import SiteStateContext from '../util/SiteStateContext.jsx';
import DoorControlWidget from '../widgets/DoorControlWidget.jsx';
import PhotoRecallWidget from '../components/PhotoRecallWidget.jsx';

const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

const useStyles = makeStyles((theme) => ({
  dataTable: {
    height: '100%',
  },
  widget: {
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  widgetWrapper: {
    width: '100%',
  },
  root: {
    flexGrow: 1,
  },
  speedDial: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(2),
    zIndex: 10000,
  },
  // TODO: 'toolTip' is referenced but not defined
}));

const DashboardPage = (props) => {
  const { setBookmarksOpened } = props;
  const classes = useStyles();
  const siteState = useContext(SiteStateContext);
  const [configuration, setConfiguration] = useState();
  const [photolayout, setPhotolayout] = useState();
  const [photosize, setPhotoSize] = useState();
  const [gridsize, setGridSize] = useState();
  const [open, setOpen] = useState(false);
  const [dialogopen, setDialogOpen] = useState(false);
  const [widgetInput, setwidgetInput] = useState();
  const [widgetID, setwidgetID] = useState();
  const [widgetPositions, setWidgetPositions] = useState([{}]);
  const [singleReaderAccessRights, setSingleReaderAccessRights] = useState([]);
  const [openSnack, setOpenSnack] = useState(false);
  const [success, setSuccess] = useState('Changes are being Saved!');
  const [errormsg, setErrorMsg] = useState('Error Making Changes!');
  const [errorSnack, setErrorSnack] = useState(false);
  const [tabWidgets, setTabWidgets] = useState([]);
  const [widgetText, setWidgetText] = useState('This is some text in state');
  const [widgetChange, setwidgetChange] = useState(0);
  const [lastItem, setLastItem] = useState();

  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
    setErrorSnack(false);
  };

  const handleErrorSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnack(false);
    setErrorSnack(false);
    setErrorMsg('Error Making Changes');
  };

  /**
   * Helper function to generate a TabRenderer component wrapper for a react component
   * @param {*} widget React Component
   * @returns
   */
  const generateTabRendering = (widget) => {
    const newKey = uuidv4();
    return (
      <TabRenderer key={newKey} title={`PremiSys\u00AE Dashboard Widget`}>
        {widget}
      </TabRenderer>
    );
  };

  /**
   * proof of concept function to show changing state changes tab content
   */
  const changeText = () => {
    if (widgetText === 'This is a text widget') {
      setWidgetText('This text has been changed in state');
    } else {
      setWidgetText('This is a text widget');
    }
  };

  /**
   * Toggle bookmark flag for a specific widget
   * @param {integer} widgetPosition index of widget to toggle
   */
  const toggleBookmark = (widgetPosition) => {
    const mutableWidgets = { ...widgetPositions };
    mutableWidgets[widgetPosition.i].bookmark = !mutableWidgets[widgetPosition.i].bookmark;
    switch (mutableWidgets[widgetPosition.i].type) {
      case 'text':
        mutableWidgets[widgetPosition.i].type = 1;
        break;

      case 'doors':
        mutableWidgets[widgetPosition.i].type = 2;

        break;

      case 'doorGroup':
        mutableWidgets[widgetPosition.i].type = 3;
        break;
      case 'photorecall':
        mutableWidgets[widgetPosition.i].type = 4;
        break;
      default:
        break;
    }
    const thiswidgetInput = {
      bookmarked: mutableWidgets[widgetPosition.i].bookmark,
      height: mutableWidgets[widgetPosition.i].h,
      width: mutableWidgets[widgetPosition.i].w,
      xPosition: mutableWidgets[widgetPosition.i].x,
      yPosition: mutableWidgets[widgetPosition.i].y,
      maxHeight: mutableWidgets[widgetPosition.i].maxH,
      maxWidth: mutableWidgets[widgetPosition.i].maxW,
      minHeight: mutableWidgets[widgetPosition.i].minH,
      minWidth: mutableWidgets[widgetPosition.i].minW,
      moveable: mutableWidgets[widgetPosition.i].moveable,
      resizeable: mutableWidgets[widgetPosition.i].resizeable,
      widgetType: mutableWidgets[widgetPosition.i].type,
    };
    setwidgetInput(thiswidgetInput);
    setwidgetChange(2);
    setOpenSnack(true);
    setWidgetPositions(mutableWidgets);
  };

  const deleteWidget = (widgetPosition) => {
    const mutableWidgetPositions = JSON.parse(JSON.stringify(widgetPositions));
    delete mutableWidgetPositions[widgetPosition.i];
    setwidgetChange(3);
    setOpenSnack(true);
    setWidgetPositions(mutableWidgetPositions);
  };

  const openInNewTab = (widgetPosition) => {
    const mutableTabWidgets = [...tabWidgets];
    mutableTabWidgets.push(widgetPosition);
    setTabWidgets(mutableTabWidgets);
  };
  const duplicateWidget = (widgetPosition) => {
    const newWidget = JSON.parse(JSON.stringify(widgetPosition));
    newWidget.i = uuidv4();
    newWidget.bookmark = false;
    const mutableWidgets = { ...widgetPositions };
    mutableWidgets[newWidget.i] = newWidget;
    const thiswidgetInput = {
      bookmarked: false,
      height: mutableWidgets[newWidget.i].h,
      width: mutableWidgets[newWidget.i].w,
      xPosition: mutableWidgets[newWidget.i].x,
      yPosition: mutableWidgets[newWidget.i].y,
      maxHeight: mutableWidgets[newWidget.i].maxH,
      maxWidth: mutableWidgets[newWidget.i].maxW,
      minHeight: mutableWidgets[newWidget.i].minH,
      minWidth: mutableWidgets[newWidget.i].minW,
      moveable: mutableWidgets[newWidget.i].moveable,
      resizeable: mutableWidgets[newWidget.i].resizeable,
      widgetType: mutableWidgets[newWidget.i].type,
    };
    setwidgetInput(thiswidgetInput);
    setwidgetChange(1);
    setOpenSnack(true);
    setWidgetPositions(mutableWidgets);
  };

  // --- begin query for doors --- //
  // --- TODO: add error handling and fully flesh out supporting logic
  const queryError = ({ graphQLErrors, networkError }) => {
    console.log(graphQLErrors);
    console.log(networkError);
    setOpenSnack(false);
    setErrorSnack(true);
  };
  // load readers
  const GET_READERS = gql`
    query singleReaderAccessRights($first: Int!) {
      readers(first: $first) {
        engageReaders {
          id
          name
          type
        }
      }
    }
  `;
  const queryReadersCompleted = (data) => {
    setSingleReaderAccessRights(data.readers.engageReaders);
  };
  const { loading: loadingSingleReader, ERROR: errorSingleReader } = useQuery(GET_READERS, {
    variables: { first: 1000 },
    notifyOnNetworkStatusChange: true,
    onCompleted: queryReadersCompleted,
    onError: queryError,
  });
  // --- end query for doors --- //

  const querygetWidgetsCompleted = (data) => {
    const obj = [];
    let positions = data.widgetData.widgets.map((widget) => {
      if (widget.Bookmarked) {
        obj.push({
          h: widget.Height,
          w: widget.Width,
          x: widget.XPosition,
          y: widget.YPosition,
          i: widget.WidgetID,
          bookmark: widget.Bookmarked,
          type: widget.WidgetType,
          maxH: widget.MaxHeight,
          maxW: widget.MaxWidth,
          minH: widget.MinHeight,
          minW: widget.MinWidth,
          moveable: widget.Moveable,
          resizeable: widget.Resizeable,
        });
      }
    });
    setWidgetPositions((widgetPositions) => obj);
  };

  const getPRsCompleted = (data) => {
    let PRWidget = data.photoRecallData.photoRecallWidgets.map((PRWidget) => PRWidget);

    if (data.photoRecallData.photoRecallWidgets.length > 0) {
      setConfiguration((configuration) => PRWidget[0].Configuration);
      setPhotolayout(PRWidget[0].Layout);
      setPhotoSize(PRWidget[0].PhotoRecallSize);
      setGridSize(PRWidget[0].GridSize);
      setwidgetID(PRWidget[0].WidgetID);
    } else {
      setErrorMsg('No PR Configuration found');
      setErrorSnack(true);
    }
  };

  const addwidgetscompleted = (data) => {
    setwidgetID(data.addWebWidget.WidgetID);
  };
  const updateWidgetCompleted = (data) => {};

  const [getWigets, { loading: loadingWidgets, ERROR: errorWidgets }] = useLazyQuery(GET_WIDGETS, {
    notifyOnNetworkStatusChange: true,
    onCompleted: querygetWidgetsCompleted,
    onError: queryError,
  });

  const [addWidget] = useMutation(ADD_WIDGET, {
    variables: { widgetInput: widgetInput },
    notifyOnNetworkStatusChange: true,
    onCompleted: addwidgetscompleted,
    onError: queryError,
  });

  const [updateWidget] = useMutation(UPDATE_WIDGET, {
    variables: { widgetInput: widgetInput, widgetInputID: widgetID },
    notifyOnNetworkStatusChange: true,
    onCompleted: updateWidgetCompleted,
    onError: queryError,
  });

  const [removeWidget] = useMutation(REMOVE_WIDGET, {
    variables: { widgetInputID: widgetID },
    notifyOnNetworkStatusChange: true,
    onCompleted: updateWidgetCompleted,
    onError: queryError,
  });

  const [getPR] = useLazyQuery(GET_PRS, {
    notifyOnNetworkStatusChange: true,
    onCompleted: getPRsCompleted,
    onError: queryError,
  });

  useEffect(() => {
    let loaded = 0; // TODO: This just always runs?
    if (loaded === 0) {
      getWigets();
      sleep(100).then(() => {});
      loaded += 1;
    }
  }, []);

  useEffect(() => {
    if (configuration) {
      addPhotoRecall(configuration);
    }
  }, [configuration]);

  useEffect(() => {
    switch (widgetChange) {
      case 1:
        addWidget();
        break;
      case 2:
        updateWidget();
        break;
      case 3:
        removeWidget();
        break;
      default:
        break;
    }
  }, [widgetChange]);

  // generate a sample data table for door data
  const readersColumns = ['doors'];
  const singleDoorData = singleReaderAccessRights.map((door) => {
    return [door.name];
  });

  const readersTable = (
    <MUIDataTable data={singleDoorData} columns={readersColumns} className={classes.dataTable} />
  );

  // positions widgets in the grid
  const onLayoutChange = (layout, olditem, newItem, placeholder) => {
    const mutableWidgetPositions = JSON.parse(JSON.stringify(widgetPositions));

    layout.forEach((itemToUpdate, index) => {
      let into = parseInt(itemToUpdate.i);
      if (mutableWidgetPositions[index]) {
        mutableWidgetPositions[index].x = itemToUpdate.x;
        mutableWidgetPositions[index].y = itemToUpdate.y;
        mutableWidgetPositions[index].w = itemToUpdate.w;
        mutableWidgetPositions[index].h = itemToUpdate.h;
      } else {
        mutableWidgetPositions.index = itemToUpdate;
      }
    });
    if (JSON.stringify(mutableWidgetPositions) !== JSON.stringify(widgetPositions)) {
      setWidgetPositions(mutableWidgetPositions);
    }
  };

  const updateDashboard = (layout) => {
    const mutableWidgetPositions = JSON.parse(JSON.stringify(widgetPositions));
    mutableWidgetPositions.forEach((widget, index) => {
      if (widget.i === lastItem) {
        switch (widget.type) {
          case 'text':
            widget.type = 1;
            break;

          case 'doors':
            widget.type = 2;

            break;

          case 'doorGroup':
            widget.type = 3;
            break;
          case 'photorecall':
            widget.type = 4;
            break;
          default:
            break;
        }
        const thiswidgetInput = {
          bookmarked: widget.bookmark,
          height: widget.h,
          width: widget.w,
          xPosition: widget.x,
          yPosition: widget.y,
          moveable: widget.moveable,
          widgetType: widget.type,
          maxHeight: widget.maxH,
          maxWidth: widget.maxW,
          minHeight: widget.minH,
          minWidth: widget.minW,
          resizeable: widget.resizeable,
        };

        const asInt = parseInt(widget.i);
        setwidgetInput(thiswidgetInput);
        setwidgetID(asInt);
        setwidgetChange(2);
        setOpenSnack(true);
      }
    });
  };
  /**
   * helper function to return a widget component
   * @param {string} widgetType type of widget to generate
   * @returns React Component
   */
  const generateWidgetComponent = (widgetType) => {
    if (widgetType === 'text' || widgetType === 1) {
      return <Typography>{widgetText}</Typography>;
    }
    if (widgetType === 'doors' || widgetType === 2) {
      return readersTable;
    }
    if (widgetType === 'doorGroup' || widgetType === 3) {
      return <DoorControlWidget />;
    }
    if (widgetType === 'photorecall' || widgetType === 4) {
      return <PhotoRecallWidget />;
    }
    return null;
  };

  /**
   * Iterates over widgetPositions state object and generates widget components to render in the data grid
   * @returns [Components]
   */
  const renderWidgets = () => {
    const renderedWidgets = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(widgetPositions)) {
      const widgetType = value.type;
      if (value.i) {
        const thisString = value.i.toString();
        value.i = thisString;
      }
      const dataGrid = { ...value };
      delete dataGrid.type;
      const widget = generateWidgetComponent(widgetType);
      if (widget) {
        renderedWidgets.push(
          <div className={`${classes.widget}`} data-grid={dataGrid} key={value.i}>
            <DashboardWidgetMenu
              widget={value}
              handleBookmark={toggleBookmark}
              handleDelete={deleteWidget}
              handleNewTab={openInNewTab}
              handleDuplicate={duplicateWidget}
            />
            <div className={classes.widgetWrapper}>{widget}</div>
          </div>
        );
      }
    }
    return renderedWidgets;
  };

  // helper functions to add new widgets
  const addText = () => {
    const mutableItems = { ...widgetPositions };
    const newKey = uuidv4();

    mutableItems[newKey] = {
      i: newKey,
      x: 0,
      y: 0,
      w: 2,
      h: 2,
      type: 'text',
      maxH: 10,
      maxW: 10,
      minH: 2,
      minW: 2,
      bookmarked: false,
      moveable: true,
      resizeable: true,
    };
    const thiswidgetInput = {
      bookmarked: false,
      height: mutableItems[newKey].h,
      width: mutableItems[newKey].w,
      xPosition: mutableItems[newKey].x,
      yPosition: mutableItems[newKey].y,
      maxHeight: 10,
      maxWidth: 10,
      minHeight: 2,
      minWidth: 2,
      moveable: true,
      resizeable: true,
      widgetType: 1,
    };
    setwidgetInput(thiswidgetInput);

    setwidgetChange(1);
    setOpenSnack(true);
    setWidgetPositions(mutableItems);
  };
  const addDoors = () => {
    const mutableItems = { ...widgetPositions };
    const newKey = uuidv4();
    mutableItems[newKey] = {
      i: newKey,
      x: 0,
      y: 0,
      w: 4,
      h: 10,
      type: 'doors',
      maxH: 10,
      maxW: 10,
      minH: 2,
      minW: 2,
      bookmarked: false,
      moveable: true,
      resizeable: true,
    };
    const thiswidgetInput = {
      bookmarked: false,
      height: mutableItems[newKey].h,
      width: mutableItems[newKey].w,
      xPosition: mutableItems[newKey].x,
      yPosition: mutableItems[newKey].y,
      maxHeight: 10,
      maxWidth: 10,
      minHeight: 2,
      minWidth: 2,
      moveable: true,
      resizeable: true,
      widgetType: 2,
    };
    setwidgetInput(thiswidgetInput);
    setwidgetChange(1);
    setOpenSnack(true);
    setWidgetPositions(mutableItems);
  };
  const addDoorGroup = () => {
    const mutableItems = { ...widgetPositions };
    const newKey = uuidv4();
    mutableItems[newKey] = {
      i: newKey,
      x: 0,
      y: 0,
      w: 4,
      h: 10,
      type: 'doorGroup',
      maxH: 10,
      maxW: 10,
      minH: 2,
      minW: 2,
      bookmarked: false,
      moveable: true,
      resizeable: true,
    };
    const thiswidgetInput = {
      bookmarked: false,
      height: mutableItems[newKey].h,
      width: mutableItems[newKey].w,
      xPosition: mutableItems[newKey].x,
      yPosition: mutableItems[newKey].y,
      maxHeight: 10,
      maxWidth: 10,
      minHeight: mutableItems[newKey].minH,
      minWidth: 2,
      moveable: true,
      resizeable: true,
      widgetType: 3,
    };
    setwidgetInput(thiswidgetInput);
    setwidgetChange(1);
    setOpenSnack(true);
    setWidgetPositions(mutableItems);
  };
  const addPhotoRecall = () => {
    getWigets();
    if (configuration) {
      const value = photolayout.includes('Value');
      let parsedValue = JSON.parse(photolayout);
      if (value) {
        const doubleparsed = JSON.parse(parsedValue.Value);
        parsedValue = doubleparsed;
      }
      const actualLayout = parsedValue;
      const photosize = Number(gridsize);
      let totwidth = 0;
      let totheight = 0;
      for (let i = 0; i < photosize; i += 1) {
        totwidth += actualLayout[i].w;
        totheight += actualLayout[i].h;
      }
      const mutableWidgets = { ...widgetPositions };
      mutableWidgets[widgetID] = {
        h: totheight * 1,
        i: widgetID,
        w: totwidth * 1,
        type: 'photorecall',
        x: 1,
        y: 1,
        resizeable: true,
        maxH: 20,
        maxW: 20,
        minH: 4,
        minW: 4,
        moveable: true,
        bookmarked: true,
      };

      const thiswidgetInput = {
        bookmarked: true,
        height: parseInt(mutableWidgets[widgetID].h),
        width: parseInt(mutableWidgets[widgetID].w),
        xPosition: mutableWidgets[widgetID].x,
        yPosition: mutableWidgets[widgetID].y,
        maxHeight: 20,
        maxWidth: 20,
        minHeight: 4,
        minWidth: 2,
        moveable: true,
        resizeable: true,
        widgetType: 4,
      };
      setwidgetInput(thiswidgetInput);
      setWidgetPositions(mutableWidgets);
      setwidgetChange(2);
      setOpenSnack(true);
    } else {
      setErrorMsg('No Photo Recall Configuration Exits');
      setErrorSnack(true);
    }
  };

  /**
   * Iterates over widgetPositions state and returns new tab components for each bookmarked widget
   * @returns [components]
   */
  const openBookmarks = () => {
    if (!siteState.bookmarksOpened) {
      const bookmarkedWidgets = [];
      Object.entries(widgetPositions).forEach((widget) => {
        const value = widget[1];
        if (value.bookmark) {
          const widgetComponent = generateWidgetComponent(value.type);
          bookmarkedWidgets.push(widgetComponent);
        }
      });
      const generatedTabWidgetRenderings = bookmarkedWidgets.map((widget) =>
        generateTabRendering(widget)
      );
      return generatedTabWidgetRenderings;
    }
    return null;
  };

  /**
   * iterates over tabWidgets state and returns array of new tab components
   * @returns [components]
   */
  const openTabs = () => {
    const tabWidgetRenderings = tabWidgets.map((widget) => {
      return generateTabRendering(generateWidgetComponent(widget.type));
    });
    return tabWidgetRenderings;
  };
  const bookmarks = openBookmarks();
  if (!siteState.bookmarksOpened) {
    // timeout is needed to give bookmarks a chance to render before updating the flag that prevents them from being rendered.
    setTimeout(() => setBookmarksOpened(), 500);
  }

  const handlePhotoRecall = () => {
    getPR();
  };

  const buttons = [
    {
      button: addDoors,
      name: 'Add Doors',
    },
    {
      button: addDoorGroup,
      name: 'Door Group',
    },
    {
      button: addText,
      name: 'Text',
    },
    {
      button: handlePhotoRecall,
      name: 'Photo Recall',
    },
  ];
  const addWidgets = () => {
    setDialogOpen(true);
  };

  const widgets = [
    {
      button: addWidgets,
      name: 'Add Widget',
      icon: <AddCircleOutlineIcon />,
    },
    {
      button: changeText,
      name: 'Change Text Widget Text',
      icon: <AddCircleOutlineIcon />,
    },
    {
      button: updateDashboard,
      name: 'Save Widget Layout',
      icon: <SaveIcon />,
    },
  ];

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleFABClose = () => {
    setOpen(false);
  };

  const itemChanged = (data) => {
    if (data) {
      const widgetID = data.newItem.i;
      setLastItem(widgetID);
    }
  };

  return (
    <>
      <Dialog open={dialogopen} onClose={handleDialogClose}>
        <DialogTitle>Select your Widget to Add: </DialogTitle>
        <DialogContent>
          <List sx={{ pt: 0 }}>
            {buttons.map((button) => (
              <ListItem
                button
                onClick={() => {
                  button.button();
                  sleep(100).then(() => {
                    handleDialogClose();
                  });
                }}
                key={button.name}
              >
                <ListItemAvatar>
                  <SpeedDialIcon />
                </ListItemAvatar>
                <ListItemText primary={button.name} />
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>
      <Typography variant="h5">Dashboard</Typography>
      <DashboardGrid
        onLayoutChange={onLayoutChange}
        renderedWidgets={renderWidgets()}
        onModifyHandler={itemChanged}
      />
      {bookmarks}
      {openTabs()}
      <div className={classes.root}>
        <SpeedDial
          ariaLabel="SpeedDial openIcon example"
          className={classes.speedDial}
          icon={<SpeedDialIcon />}
          onClose={handleFABClose}
          onOpen={handleOpen}
          open={open}
        >
          {widgets.map((button) => (
            <SpeedDialAction
              key={button.name}
              icon={button.icon}
              tooltipTitle={button.name}
              className={classes.toolTip}
              TooltipClasses={classes.toolTip}
              onClick={button.button}
              tooltipOpen
            />
          ))}
        </SpeedDial>
      </div>
      <Snackbar open={openSnack} autoHideDuration={2000} onClose={handleSnackBarClose}>
        <Alert open={openSnack} severity="success" onClose={handleSnackBarClose}>
          {success}
        </Alert>
      </Snackbar>
      <Snackbar open={errorSnack} autoHideDuration={2000} onClose={handleErrorSnackBarClose}>
        <Alert open={errorSnack} severity="error" onClose={handleErrorSnackBarClose}>
          {errormsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DashboardPage;
